const publicPath = require('../config/index').jsonPath;
import publishObjectPath from '@/util/configRegistry';
import { RequireFilter } from '@/filter/RequireFilter';
import { RequestServerClass } from '@/util/request';
const configServerPath: any = publishObjectPath.value.serverPath;

import { MapService } from './mapmodule/MapService';
import { PlotServer } from './plot/plotServer';
import { PlotNoSqlService } from './plot/plotNoSqlService';
import { MapServer } from './mapServer/mapServer';

if (window.location.href.split('?token=')[1] === 'NotHave') {
  $.ajax({
    type: 'POST',
    async: false,
    contentType: 'application/json;charset=UTF-8',
    url: publishObjectPath.value.upLoadPath + '/gemp-user/api/gemp/duty/info/user/login/v1',
    data: JSON.stringify(publishObjectPath.value.dispatchLogin),
    success: (result) => {
      (localStorage as any).setItem('token', result.data.token);
    },
    error: (e) => {
        console.log(e.status);
        console.log(e.responseText);
    },
  });
}

const requireFilter: RequireFilter = new RequireFilter();
const injectFilter: any = (servObj: any) => {
  requireFilter.axiosFilter.request(servObj);
  requireFilter.axiosFilter.response(servObj);
};

const mapService = new MapService({ baseURL: publicPath });
const plotServer = new PlotServer({ baseURL: publicPath }, injectFilter);
const plotNoSqlService = new PlotNoSqlService(
  { baseURL: publicPath },
  injectFilter,
);
const mapServer = new MapServer(
  { baseURL: configServerPath },
  injectFilter,
);
export { mapService, plotServer, plotNoSqlService, mapServer };
